// extracted by mini-css-extract-plugin
export default {"wrapper":"ORE05","svg":"itzfA","track":"lgT0d","indicator":"SBwqi","indicatorSpinner":"SutaG","spinner":"ysi6Y"};